import { useEffect, useState } from "react";
import { api } from "../lib/api";
import FacultyDrilldown from "../components/FacultyDrilldown";

const statusBadge = (s) => s === 'Met' ? 'ok' : s === 'Near' ? 'warn' : 'bad';
const barColor = (s) => s === 'Met' ? 'var(--ok)' : s === 'Near' ? 'var(--warn)' : (s === 'Short' ? '#C48A1A' : 'var(--bad)');

const clickCell = {cursor:'pointer',textDecoration:'underline',textDecorationStyle:'dotted',textUnderlineOffset:3};

export default function Strength() {
  const [rows, setRows] = useState([]);
  const [drill, setDrill] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/stats/department-strength")
      .then(({data}) => { if (alive) setRows(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const openDrill = (dept, desig) => {
    const title = desig ? `${desig} — ${dept}` : dept;
    setDrill({ department: dept, designation: desig || undefined, title });
  };

  return (
    <div data-testid="view-strength">
      <div className="topbar">
        <div>
          <h1 className="pg-title">Department Strength</h1>
          <div className="pg-sub">Actual versus required faculty at each designation level, derived from NMC norms · click any cell to drill down</div>
        </div>
      </div>
      <div className="card">
        <table className="data">
          <thead>
            <tr>
              <th>Department</th><th>Type</th>
              <th style={{textAlign:'center'}}>Prof</th>
              <th style={{textAlign:'center'}}>Assoc</th>
              <th style={{textAlign:'center'}}>Asst</th>
              <th style={{textAlign:'center'}}>SR</th>
              <th>Fill</th><th>Status</th>
            </tr>
          </thead>
          <tbody data-testid="strength-tbody">
            {rows.map(r => (
              <tr key={r.department}>
                <td>
                  <span className="dept-name" style={clickCell} onClick={() => openDrill(r.department, null)} data-testid={`dept-${r.department}`}>
                    {r.department}
                  </span>
                </td>
                <td><span className="dept-sub">{r.type}</span></td>
                <td className="num" style={clickCell} onClick={() => openDrill(r.department, 'Professor')}>{r.prof}</td>
                <td className="num" style={clickCell} onClick={() => openDrill(r.department, 'Associate Professor')}>{r.assoc}</td>
                <td className="num" style={clickCell} onClick={() => openDrill(r.department, 'Assistant Professor')}>{r.asst}</td>
                <td className="num" style={clickCell} onClick={() => openDrill(r.department, 'Senior Resident')}>{r.sr}</td>
                <td>
                  <div className="bar-sm"><span style={{width:`${r.fill_pct}%`, background: barColor(r.status)}}/></div>
                  <span style={{fontFamily:'var(--mono)', fontSize:11, color:'var(--text-2)'}}>{r.fill_pct}%</span>
                </td>
                <td><span className={`badge ${statusBadge(r.status)}`}>{r.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {drill && <FacultyDrilldown department={drill.department} designation={drill.designation} title={drill.title} onClose={() => setDrill(null)}/>}
    </div>
  );
}
